import { zergApi } from "@/service/zerg";

class LaborRegimeService {
    async getPaymentSetting(params) {
        try {
            const data = await zergApi.post('setting/payroll/labor-regime/get-labor-regime', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async insertOrUpdateLaborRegime(params) {
        try {
            const data = await zergApi.post('setting/payroll/labor-regime/insert-update-labor-regime', params);
            return data;
        } catch (error) {
            return error;
        }
    }
}

export default new LaborRegimeService();